import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from "react-helmet";

import Btn from '../../Components/Btn';
import { bindActionCreators } from 'redux';
import { resetPassword } from '../../store/user/actions';
import { loaderstyle } from '../../config';
import LoadingOverlay from 'react-loading-overlay';
import Alert from '../../Components/Alert';

class ResetPassword extends Component {
  state = {
    new_password: '',
    confirm_password: ''
  }

  componentDidMount() {
    console.log(this.props);
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  goToLogin = () => {

    this.props.history.replace("/login");
  }

  /**
   * @param {Event} e
   */
  resetPassword = (e) => {
    e.preventDefault();
    // reset
    this.props.resetPassword(this.props.match.params.token, this.state.new_password, this.state.confirm_password, this.goToLogin.bind(this));
  }

  render() {
    const { loading, error } = this.props.user.resetPassword;

    return (
      <div className="login-page">
        <Helmet>
          <title>Reset Password | Go Bus Dashboard</title>
        </Helmet>
        <div className="login-widget">
          <div className="login-widget-head">
            <img src="/imgs/logo-border.png" alt="Go Bus Logo" />
            <h1>Go Bus Dashboard</h1>
          </div>
          <div className="login-widget-content">
            <LoadingOverlay
              active={loading}
              // text=""
              spinner
              styles={loaderstyle}
            >
              <form onSubmit={this.resetPassword}>
                <h3>Reset your password</h3>

                <Alert
                  msg={error}
                  color="red" />
                <div className="form-field">
                  <h5 className="label">New Password</h5>
                  <input name="new_password" type="password" onChange={this.handleInput} value={this.state.new_password} />
                </div>
                <div className="form-field">
                  <h5 className="label">Confirm New Password</h5>
                  <input name="confirm_password" type="password" onChange={this.handleInput} value={this.state.confirm_password} />
                </div>
                <Btn className="btn submit full" >Reset Password</Btn>
              </form>
            </LoadingOverlay>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  resetPassword: bindActionCreators(resetPassword, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPassword))
